module.exports = [{"code":"BRN","Desc_en":"BRN"},{"code":"NRIC","Desc_en":"NRIC"},{"code":"PASSPORT","Desc_en":"PASSPORT"}]


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/components/e-invoice/IdentificationTypes.json
// module id = 7Djb
// module chunks = 50